import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/rate-informations', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/rate-informations', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/rate-informations/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/rate-informations/${data.rate_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/rate-informations/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const currency = (Options = {}) => {
  return httpClient
    .get(
      '/api/currencies?perPage=-1&fields[currencies]=currency_id,currency_code,currency_name_en,currency_sign'
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  currency
}
